<div class="simple-bar-chart-container">
  <div class="eliso-card-title">{{ titleText() }}</div>
  @if (chartOptions(); as options) {
    <div echarts [options]="options"></div>
  }
</div>
